var CMD = (function () {
    function CMD() {
    }
    return CMD;
}());
//# sourceMappingURL=CMD.js.map